export const getTitleKey = ({
  shouldRenderVariation,
  shouldUsePaTitle,
}: {
  shouldRenderVariation: boolean
  shouldUsePaTitle: boolean
}): string => {
  if (shouldRenderVariation) {
    return 'onboarding.selectGenderAyah.titleVariation'
  }

  if (shouldUsePaTitle) {
    return 'onboarding.selectGenderAyah.paTitle'
  }

  return 'onboarding.selectGenderAyah.title'
}
